import { Component, Input } from '@angular/core';
import { Asset,Product, ProductVariant, SearchResult} from '../../graphql/generated/generated-types';
import { StateService } from '../../core/state/old/state.service';
import { AssetPreviewPipe } from '../pipes/asset-preview.pipe';
import { ProductDetailsHeaderComponent } from '../components/product/product-details-header/product-details-header.component';
import { ButtonModule } from 'primeng/button';
import { ProductImageWrapperComponent } from '../components/product/product-image-wrapper/product-image-wrapper.component';
import { RippleModule } from 'primeng/ripple';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RequestPartDialogComponent } from '../dialogs/request-part-dialog/request-part-dialog.component';

export enum ToastSeverity {
    Custom = 'custom',
    Error = 'error',
    Success = 'success',
    Warning = 'warning',
    Info = 'info'
 }

 export interface IToastActions {
    viewCart?: boolean,
    requestMore?: boolean,
    cancel?: boolean,
    ok?: boolean
 }


@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [AssetPreviewPipe, ProductDetailsHeaderComponent, ButtonModule, ProductImageWrapperComponent, RippleModule, RequestPartDialogComponent],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  @Input() summary: any;
  @Input() featuredAsset!: Asset;
  @Input() productName!: string;
  @Input() cartNotification: boolean = false;
  @Input() quantity!: any;
  @Input() severity!: ToastSeverity;
  @Input() message!: string;
  @Input() actions: IToastActions

  @Input() product!: Product;
  @Input() searchResult!: SearchResult;
  @Input() productVariant!: ProductVariant;


  public ToastSeverity = ToastSeverity;
  constructor(private stateService: StateService, private dialogService: DialogService
  ){
  }
  
  public openCartSidenav(){
    this.stateService.setState('cartSidebarVisible', true);
  }

  public openRequestPartDialog() {
    this.dialogService.open(RequestPartDialogComponent,
      {
        modal: true,
        dismissableMask: true,
        styleClass: 'c-dialog medium-dialog',
        header: 'Request item',
        data: {
          productVariantId: this.searchResult?.productVariantId || this.productVariant?.id || this.product?.variants[0]?.id,
          name: this.searchResult?.productName || this.productVariant?.name || this.product?.name,
          slug: this.searchResult?.slug || this.productVariant?.product?.slug || this.product?.slug,
          manufacturer: this.searchResult?.customAttributes?.manufacturer  || this.productVariant?.product?.customAttributes?.manufacturer || this.product?.customAttributes?.manufacturer,
          sku: this.searchResult?.sku || this.productVariant?.sku || this.product?.variants[0]?.sku,
          featuredAsset: this.searchResult?.productAsset || this.productVariant?.featuredAsset || this.featuredAsset || this.product?.variants[0]?.featuredAsset,  
        }
      });

  }

  
}
